export default __webpack_public_path__ + "static/media/logo-sq.a6fbea3f.png";